export const DATE_FORMAT = 'DD.MM.YYYY'
export const TIME_FORMAT = 'HH:mm'
export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm'
export const DATE_TIME_SECONDS_FORMAT = 'DD.MM.YYYY HH:mm:ss'

export const START_DATE_TIME_ISO_SUFFIX = 'T00:00:00.000Z'
export const END_DATE_TIME_ISO_SUFFIX = 'T23:59:59.000Z'

export const LOCALE = {
  CS: 'cs-CZ',
}

const DAY_MS = 24 * 60 * 60 * 1000

const DATE_FORMAT_DELIMITER = '.'
const DATE_TIME_DELIMITER = ' '
const ISO_DATE_TIME_DELIMITER = 'T'
const ISO_DATE_DELIMITER = '-'

/**
 * @param {string} date - 2021-05-06
 * @returns {string} - 06.05.2021
 */
export function isoDateToDateFormat (date) {
  const [year, month, day] = String(date).split(ISO_DATE_DELIMITER)
  return [day, month, year].join(DATE_FORMAT_DELIMITER)
}

/**
 * @param {string} dateTime - 2021-05-06T10:00
 * @returns {string} - 06.05.2021 10:00
 */
export function isoDateTimeToDateTimeFormat (dateTime) {
  const [date, time] = String(dateTime).split(ISO_DATE_TIME_DELIMITER)
  return isoDateToDateFormat(date) + DATE_TIME_DELIMITER + time
}

/**
 * @param {string} date - 06.05.2021
 * @returns {string} - 2021-05-06
 */
export function dateFormatToIsoDate (date) {
  const [day, month, year] = String(date).split(DATE_FORMAT_DELIMITER)
  return [year, month, day].join(ISO_DATE_DELIMITER)
}

/**
 * @param {string} dateTime - 06.05.2021 10:00
 * @returns {string} - 2021-05-06T10:00
 */
export function dateTimeFormatToIsoDateTime (dateTime) {
  const [date, time] = String(dateTime).split(DATE_TIME_DELIMITER)
  return dateFormatToIsoDate(date) + ISO_DATE_TIME_DELIMITER + (time === undefined ? '00:00:00' : time)
}

/**
 *
 * @param {string} date - 06.05.2021
 * @param {number} daysToAdd - 1
 * @returns {string} - 07.05.2021
 */
export function addDaysToDateFormat (date, daysToAdd) {
  const isoDate = dateFormatToIsoDate(date)
  const newDateMs = new Date(isoDate).getTime() + (DAY_MS * daysToAdd)
  const newIsoDate = new Date(newDateMs).toISOString().split('T')[0]

  return isoDateToDateFormat(newIsoDate)
}

export function changeDaysInDate (date, days = 0) {
  days >= 0
    ? date.setDate(date.getDate() + days)
    : date.setDate(date.getDate() - Math.abs(days))

  return date
}

/**
 *
 * @param {Date} date
 * @param {string} locale
 * @param {object} options
 * @returns {string} - 07.05.2021
 */
export function getFormattedLocaleDateString (date, locale, options = {}) {
  return (new Date(date))
    .toLocaleDateString(
      locale,
      {
        day: options.day || '2-digit',
        month: options.month || '2-digit',
        year: options.year || 'numeric'
      })
    .replace(/ /g, options.replacer || '')
}
